// extracted by mini-css-extract-plugin
var _1 = "PayoutsDetailsDialog_dialog__INbYy";
var _2 = "PayoutsDetailsDialog_navBar__b9LOO";
var _3 = "PayoutsDetailsDialog_tabContent__XXbU9";
export { _1 as "dialog", _2 as "navBar", _3 as "tabContent" }
